module.exports = __webpack_public_path__ + "static/img/ai.f247df2f.png";